export default [
    {key: 'title'},
    {key: 'free', name: 'Free', price: 0},
    {key: 'team', name: 'Team', price: 20},
    {key: 'enterprise', name: 'Enterprise', price: 50},
]